export default {
  label: {
    planAVisit: "Programe una Visita",
    askAQuestion: "Haga una Pregunta",
    name: "Nombre",
    email: "Correo electrónico",
    phone: "Teléfono",
    subject: "Tema",
    message: "Mensaje",
    dateOfVisit: "Fecha de Visita",
    buildAPlaylist: "Arme una lista de videos",
    scrollDown: " Desplazarse hacia abajo ",
    categories: "Categorías",
    featured: "Destacados",
  },
  button: {
    giveOnline: " Dar en línea ",
    close: "Cerrar",
    sendMessage: "Envié un mensaje",
    createPlaylist: " Arme una lista de videos",
    viewMore: "Ver más",
    goToTop: "Ir al principio",
  },
  error: {
    name: "Favor de poner su nombre.",
    email: "Favor de poner su correo electrónico.",
    phone: "Favor de poner su teléfono.",
    message: "Favor de poner su mensaje.",
    dateOfVisit: "Favor de poner fecha de visita.",
    subject: "Favor de poner tema",
  },
  placeholder: {
    searchForAnswers: "Buscar respuestas",
  },
};
